const PERMISSION_KEY= "core:promotion_rule";
const PAGE_URL = {
    PROMOTION_RULE_PAGE: "/admin/core/promotion-rule"
}

export {PERMISSION_KEY, PAGE_URL}

